// ServiceContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Departments from "./Departments"; 

// Create the context
const ServiceContext = createContext();

// Context Provider Component
export const ServiceProvider = ({ children }) => {
  const { serviceName } = useParams(); 
  const [service, setService] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [serviceName]);

  useEffect(() => {
    // Find the service from the medical or surgical list
    const foundService =
      Departments.medical.find(
        (s) => s.metaUrl === serviceName
      ) ||
      Departments.surgical.find(
        (s) => s.metaUrl === serviceName
      );

    setService(foundService);
  }, [serviceName]);

  return (
    <ServiceContext.Provider value={{ service }}>
      {children}
    </ServiceContext.Provider>
  );
};

// Custom hook to use the context
export const useService = () => {
  const context = useContext(ServiceContext);
  if (!context) {
    throw new Error("useService must be used within a ServiceProvider");
  }
  return context;
};

export default ServiceContext;